import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import api from "../../libs/api";

import AssistantCard from "../Card/AssistantCard";
import Billing from "../Billing/Billing";
import CancellationNotifications from "../CancellationNotifications/CancellationNotifications";
import MatchingButton from "../MatchingButton/MatchingButton";
import Review from "../Review/Review";

import "./Dashboard.scss";

function Dashboard({ assistants, client, profile, history }) {
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviewFormProps, setReviewFormProps] = useState({});
  const [otRequests, setOtRequests] = useState();

  const assistantCards = assistants.map((assistant, i) => {
    const otRequest = (otRequests || []).find((ot) => {
      return ot.status === "REQUESTED" && assistant.user_id === ot.user_id;
    });

    return (
      <AssistantCard
        key={i}
        assistant={assistant}
        client={client}
        history={history}
        showReviewForm={({ assistant, review }) => {
          window.scrollTo({ top: 0 });
          setReviewFormProps({ assistant, review });
          setShowReviewForm(true);
        }}
        otRequest={otRequest}
      />
    );
  });

  const displayTitle = () => {
    if (!client || Object.keys(client).length === 0 || !client.name) {
      return `Welcome!`;
    } else {
      return `Welcome, ${client.name}!`;
    }
  };

  const title = displayTitle();

  useEffect(() => {
    async function getOts() {
      const { data } = await api.get("/dtrs/ots");
      setOtRequests(data);
    }
    if (assistants.length && !otRequests) {
      getOts();
    }
  }, [assistants, otRequests]);

  if (showReviewForm)
    return <Review {...reviewFormProps} onDismiss={() => setShowReviewForm(false)} />;

  return (
    <div
      data-testid="Dashboard"
      id="dashboard"
      className="container-fluid container-xl container-lg my-0 mx-auto px-0"
    >
      <CancellationNotifications />
      <div className="header-container">
        <h2 className="mg-b-l">{title}</h2>
      </div>
      <div id="cards" className="assistants mb-4">
        {assistantCards}
      </div>
      <div className="add-assistants-container">
        <MatchingButton />
      </div>
      <Billing client={client} profile={profile} />
    </div>
  );
}

export default withRouter(Dashboard);
